import React, { FC } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import * as paths from 'paths';
import { useGetPublicUserProfileQuery } from 'api';
import { Loaders } from 'components';
import { FOLLOW_QUERIES_LIMIT } from 'app-constants';
import { useFollowedAllResultsQuery, useNotify } from 'hooks';

import { ProfileController } from '../components';

const Profile: FC = () => {
  const { profile_id } = useParams<{ profile_id: string }>();
  const notify = useNotify();

  const variables = { data: { user_id: profile_id, limit: FOLLOW_QUERIES_LIMIT } };
  const { data, isLoading } = useGetPublicUserProfileQuery(
    { user_id: profile_id },
    {
      onError: notify.queryError,
    }
  );

  /**
   * TODO: This query returns all groups and profiles associated with an account, so
   * we set a high limit and hope for the best. We need separate queries for followed
   * groups and followed users
   */
  const followedResults = useFollowedAllResultsQuery(variables, {
    onError: notify.queryError,
  });

  if (isLoading) {
    return <Loaders.Standard />;
  }

  if (!data.getPublicUserProfile) {
    return <Navigate to={paths.team} replace />;
  }

  return <ProfileController user={data.getPublicUserProfile} followedResults={followedResults} />;
};

export default Profile;
